"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateBarCode = function (digits) {
    var checkDigit = 0;
    var sum = 0;
    digits = '0'.concat(digits);
    while (digits.length < 12) {
        digits = '5'.concat(digits);
    }
    var digitsArray = digits.split('');
    for (var i = 0; i < digitsArray.length; i++) {
        var weight = 1;
        if ((i - 1) % 2 === 0) {
            weight = 3;
        }
        sum += (parseInt(digitsArray[i], 10) * weight);
    }
    var modulo = sum % 10;
    if (modulo !== 0) {
        checkDigit = 10 - modulo;
    }
    return digits.concat(checkDigit.toString());
};
